import { BrowserModule } from '@angular/platform-browser';
import { APP_INITIALIZER, NgModule } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { AppComponent } from './app.component';
import { NotFoundComponent } from './modules/general/not-found/not-found.component';
import { AppRoutingModule } from './app-routing.module';
import { provideHttpClient, withInterceptorsFromDi } from '@angular/common/http';
import { languageReducer } from './reducer';
import { StoreModule } from '@ngrx/store'
import { InitLanguagesService } from './service/language/init-languages.service';
import { AppTreeComponent } from './app-tree/app-tree.component';

export function appInit(initLanguagesService: InitLanguagesService) {
  return () => initLanguagesService.loadLanguages();
}

@NgModule({ declarations: [
        AppComponent,
        NotFoundComponent,
        AppTreeComponent
    ],
    bootstrap: [AppComponent], imports: [BrowserModule,
        AppRoutingModule,
        FormsModule,
        StoreModule.forRoot({ lang: languageReducer }),
        BrowserAnimationsModule], providers: [InitLanguagesService,
        {
            provide: APP_INITIALIZER,
            useFactory: appInit,
            multi: true,
            deps: [InitLanguagesService]
        }, provideHttpClient(withInterceptorsFromDi())] })
export class AppModule { }